import {LanguageFr} from './language.fr';

export class LanguageFrFR extends LanguageFr {
  LanguageCode: string = 'fr-fr';
  LanguageDescription: string = 'Français/France';
  Currency = '{{v}} €';
  CurrencySymbol = '€';
  Meal1Label = 'Déjeuner';
  Meal2Label = 'Diner';
  Lunch = 'Déjeuner';
  Supper = 'Diner';
  provState='Département';
  telCell = 'Portable';
  telPage = 'Téléavertisseur';


}
